"use client";

import { SpecOptionPills } from "@/components/listing/FurnitureOptionalDimensionsFields";
import {
  APPLIANCE_INVERTER_TYPES,
  MICROWAVE_SMART_TYPES,
  type ApplianceInverterType,
  type MicrowaveSmartType,
} from "@/lib/listing/applianceInverterListingSpec";
import type { MicrowaveSpecFormState } from "@/lib/listing/microwaveListingSpec";
import { cn } from "@/lib/utils";

interface MicrowaveSpecFieldsProps {
  value: MicrowaveSpecFormState;
  onChange: (next: MicrowaveSpecFormState) => void;
  className?: string;
}

function formatInverterLabel(value: ApplianceInverterType): string {
  return value === "inverter" ? "Inverter" : "Non-inverter";
}

function formatSmartLabel(value: MicrowaveSmartType): string {
  return value === "smart" ? "Smart" : "Non-smart";
}

/**
 * Step 2 panel for microwave (canonical `microwave`).
 * Smart type + inverter type both required.
 */
export default function MicrowaveSpecFields({
  value,
  onChange,
  className = "",
}: MicrowaveSpecFieldsProps) {
  return (
    <div className={cn("space-y-6", className)}>
      <div className="space-y-2">
        <p className="text-sm font-medium text-foreground">
          Smart type <span className="text-red-500">*</span>
        </p>
        <SpecOptionPills
          options={[...MICROWAVE_SMART_TYPES]}
          selected={value.microwaveSmartType}
          onSelect={(microwaveSmartType: MicrowaveSmartType) =>
            onChange({ ...value, microwaveSmartType })
          }
          formatLabel={formatSmartLabel}
        />
      </div>

      <div className="space-y-2">
        <p className="text-sm font-medium text-foreground">
          Inverter type <span className="text-red-500">*</span>
        </p>
        <SpecOptionPills
          options={[...APPLIANCE_INVERTER_TYPES]}
          selected={value.applianceInverterType}
          onSelect={(applianceInverterType: ApplianceInverterType) =>
            onChange({ ...value, applianceInverterType })
          }
          formatLabel={formatInverterLabel}
        />
      </div>
    </div>
  );
}
